<script lang="ts" setup>
import { useForwardPropsEmits } from 'radix-vue';
import { DrawerRoot } from 'vaul-vue';

import type { DrawerRootEmits, DrawerRootProps } from 'vaul-vue';

interface CustomDrawerProps extends Omit<DrawerRootProps, 'direction'> {
  direction?: 'bottom' | 'right';
}

const props = withDefaults(defineProps<CustomDrawerProps>(), {
  shouldScaleBackground: true,
  direction: 'bottom',
});
const emits = defineEmits<DrawerRootEmits>();
const forwarded = useForwardPropsEmits(props, emits);
</script>

<template>
  <DrawerRoot v-bind="forwarded">
    <slot />
  </DrawerRoot>
</template>
